import { UploadFile } from 'antd'
import { ImageAsset } from '@/types/assets'

export const checkImageAsset = (img: ImageAsset | UploadFile): img is ImageAsset => (img as ImageAsset)?.srcSet != null
